export const NotificationChannelIds = {
  Email: "fe269bd0-96bf-4c7d-85c7-da9476ace5e4",
  InApp: "410608e3-4003-47d7-9afb-fe3567d935b7",
} as const;

export const channelChipColor = (
  channelId?: string,
): "warning" | "secondary" | "info" | "default" => {
  const normalizedId = channelId?.toLowerCase();
  if (normalizedId === NotificationChannelIds.Email) return "info";
  if (normalizedId === NotificationChannelIds.InApp) return "warning";
  return "default";
};
